import { combineReducers } from 'redux'
import auditDucks from './common/audit.Ducks'
import settingDucks from './common/setting.Ducks'
import userDucks from './common/user.Ducks'
import notificationDucks from './common/notification.Ducks'
import commonAppDucks from './common/commonApp.Ducks'
import commonDucks from './common/common.Ducks'
import menuDucks from './common/menu.Ducks'
import poupDucks from './common/poup.Ducks'
import bangLuongDucks from './bangLuong.Ducks'
import chamCongDucks from './chamCong.Ducks'
import donTuDucks from './donTu.Ducks'
import hanhChinhDucks from './hanhChinh.Ducks'
import mangXaHoiDucks from './mangXaHoi.Ducks'
import nhanSuDucks from './nhanSu.Ducks'
import tuyenDungDucks from './tuyenDung.Ducks'

const rootReducer = combineReducers({
  audit: auditDucks,
  setting: settingDucks,
  user: userDucks,
  notification: notificationDucks,
  common: commonDucks,
  commonApp: commonAppDucks,
  menu: menuDucks,
  poup: poupDucks,
  bangLuong: bangLuongDucks,
  chamCong: chamCongDucks,
  donTu: donTuDucks,
  hanhChinh: hanhChinhDucks,
  mangXaHoi: mangXaHoiDucks,
  nhanSu: nhanSuDucks,
  tuyenDung: tuyenDungDucks,
})

export default rootReducer
